/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SandboxUsageOperation = {
  SessionStart: "session_start",
  SessionStop: "session_stop",
  SessionTerminate: "session_terminate",
  Turn: "turn",
  RepoTask: "repo_task",
  Command: "command",
  Code: "code",
  WorkspaceManifest: "workspace_manifest",
  WorkspaceDownload: "workspace_download",
  WorkspaceArchiveDownload: "workspace_archive_download",
  WorkspaceUpload: "workspace_upload",
  WorkspaceArchiveUpload: "workspace_archive_upload",
} as const;
export type SandboxUsageOperation = ClosedEnum<typeof SandboxUsageOperation>;

/** @internal */
export const SandboxUsageOperation$inboundSchema: z.ZodNativeEnum<
  typeof SandboxUsageOperation
> = z.nativeEnum(SandboxUsageOperation);
/** @internal */
export const SandboxUsageOperation$outboundSchema: z.ZodNativeEnum<
  typeof SandboxUsageOperation
> = SandboxUsageOperation$inboundSchema;
